<template>
  <div>
    <DashboardHeader title="Manage Images">
      <ManageImageTiles :folders="folders"></ManageImageTiles>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import ManageImageTiles from "@/components/myLibrary/ManageImageTiles.vue";
export default {
  components: {
    DashboardHeader,
    ManageImageTiles,
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },

  data() {
    return {
      folders: [
        {
          text: "Company Logo",
          value: "logos",
        },
        {
          text: "Website Front Page",
          value: "website_banner",
        },

        {
          text: "Management Team",
          value: "smt",
        },
        {
          text: "Gallery",
          value: "gallery",
        },
        {
          text: "Company Events",
          value: "events",
        },
        {
          text: "Staff Gallery",
          value: "staff",
        },
      ],
    };
  },
};
</script>

<style></style>
